module.exports = __webpack_public_path__ + "static/media/mountain-center.67fc8b21.svg";